import { EventBus } from '@/event-bus'
import { Events } from '@/models/events.model'
import { useTraceDataStore } from '@/stores/traceDataStore'
import { injectTyped } from '@/inject'
import { ServiceKeys } from '@/services/symbols'

export function useRegisterElementRightClickEvent() {
  const rappidContext = injectTyped(ServiceKeys.rappidContext)

  const traceDataStore = useTraceDataStore()

  function registerElementRightClickEvent(): void {
    rappidContext.paper.on('element:contextmenu', (cellView, evt) => {
      evt.preventDefault()
      evt.stopPropagation()

      const currentArtifactType = cellView.model.attributes.artifactType
      if (currentArtifactType) {
        const artifactTypeFromStore = traceDataStore.modelState.artifactTypes.find(
          (at: { id: number }) => at.id === currentArtifactType.id,
        )
        if (artifactTypeFromStore && evt.clientX && evt.clientY) {
          const inputData: Events['openContainerMenuArtifactType'] = {
            artifactType: artifactTypeFromStore,
            position: { x: evt.clientX + 20, y: evt.clientY + 20 },
            cellView: cellView,
          }
          EventBus.emit('openContainerMenuArtifactType', inputData)
        }
      }
    })
  }

  return { registerElementRightClickEvent }
}
